import { manageErrorBox, manageSuccessBox, stopSpinnerSucessBox } from './uxManagement';
import { clearCart, checkoutCartUpdateQty, checkoutCartRemoveItem } from './localStorage';

const xml2js = require('xml2js');

export function showCheckout() {
  const cartListBody = document.getElementById('cart-list-body');
  const checkoutContainer = document.getElementById('checkout-container');
  const cartItems = JSON.parse(localStorage.getItem('cart'));
  const removeItemCartButtons = document.getElementsByClassName('remove-item-cart-button');
  let totaltAmount = 0;
  /*
  hideBackButton();
  showContinueShopping(); */

  const children = cartListBody.querySelectorAll('*');
  children.forEach(child => {
    child.remove();
  });

  for (let index = 0; index < cartItems.length; index++) {
    let productItem = `
      <td class="w-16 cart-item-img">
        <img
          src="https://www.honsboa.se/images/prod450/${cartItems[index].item}.jpg" alt="" onerror="style='object-fit:cover'; 
          this.onerror=null;this.src='https://pyramidplus.webblandskapet.se/honsboa/assets/pictures/missing_image.png';"
          class="h-16 w-16 object-contain"
        />
      </td>

      <td class="cart-item-id" value="${cartItems[index].item}">
        ${cartItems[index].item}
      </td>

      <td>
        <div>
          <h3 class="text-sm text-gray-900">${cartItems[index].name}</h3>
        </div>
      </td>

      <td>
        <div class="d-flex" style="column-gap: 10px;">`;

    if (cartItems[index].bulkProduct == 'J') {
      if (cartItems[index].decimals == '1') {
        productItem += `<input type="number" step="0.1" min="0" data-decimals="1" value="${cartItems[index].qty}" name="item-amount">`;
      } else if (cartItems[index].decimals == '2') {
        productItem += `<input type="number" min="0" value="${cartItems[index].qty}" data-decimals="2" step="0.01" name="item-amount">`;
      } else {
        productItem += `<input type="number" min="0" value="${cartItems[index].qty}" step="1" data-decimals="0" name="item-amount">`;
      }
    } else {
      productItem += `
        <button data-action="decrement" class="h-full cursor-pointer ">
        <span class="m-auto text-2xl font-thin">−</span>
      </button>
      <input type="text" min="0" value="${cartItems[index].qty}" step="1" data-decimals="0" class="outline-none focus:outline-none text-center  font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none" name="custom-input-number" value="${cartItems[index].qty}"></input>
      <button data-action="increment" class="h-full cursor-pointer">
        <span class="m-auto text-2xl font-thin">+</span>
      </button>
      `;
    }

    productItem += `</div>
      </td>

        <td>
          <p class="item-price items-center flex">${cartItems[index].price} kr</p>
        </td>
        
        <td>
          <p class="item-amount items-center flex">${cartItems[index].amount} kr</p>
        </td>

        <td>
        <button class="remove-item-cart-button text-gray-600 transition hover:text-red-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-4 w-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
        </button>
      </td>
    `;

    const placeholder = document.createElement('tr');
    placeholder.innerHTML = productItem;
    cartListBody.appendChild(placeholder);
    totaltAmount += cartItems[index].amount;
  }

  const decrementButtons = document.querySelectorAll(
    'button[data-action="decrement"]'
  );

  const incrementButtons = document.querySelectorAll(
    'button[data-action="increment"]'
  );

  const amountInput = document.querySelectorAll(
    '#cart-list-body input'
  );

  decrementButtons.forEach(btn => {
    btn.addEventListener('click', decrement);
  });

  incrementButtons.forEach(btn => {
    btn.addEventListener('click', increment);
  });

  amountInput.forEach(input => {
    input.addEventListener('input', validateDecimal, false);
  });

  document.getElementById('cart-total-amount-container').textContent = `${Math.round(totaltAmount)}`;
  checkoutContainer.classList.add('visible');

  document.getElementById('card-payment').addEventListener('click', function() {
    document.getElementById('user-info').classList.add('hidden');
  });

  document.getElementById('swish-payment').addEventListener('click', function() {
    document.getElementById('user-info').classList.remove('hidden');
  });

  document.getElementById('invoice-payment').addEventListener('click', function() {
    document.getElementById('user-info').classList.remove('hidden');
  });

  if (localStorage.getItem('wlUserInformation') && localStorage.getItem('wlUsername') && localStorage.getItem('wlPassword')) {
    // Användare är inloggad
    const savedUserInformation = JSON.parse(localStorage.getItem('wlUserInformation'));
    if (savedUserInformation.AllowedPaymentMethods) {
      if (savedUserInformation.AllowedPaymentMethods.indexOf('S') > -1) {
        // Swish
        document.getElementById('swish-payment-wrap').classList.remove('hidden');
      }
      if (savedUserInformation.AllowedPaymentMethods.indexOf('E') > -1) {
        // Kort
        document.getElementById('card-payment-wrap').classList.remove('hidden');
      }
      if (savedUserInformation.AllowedPaymentMethods.indexOf('I') > -1) {
        // Faktura
        document.getElementById('invoice-payment-wrap').classList.remove('hidden');
      }
    }
    const customerName = savedUserInformation.CustomerName.split(' ');
    let firstName = savedUserInformation.CustomerName;
    let lastName = '';
    if (customerName.length > 1) {
      firstName = customerName[0];
      lastName = customerName[1];
    }
    document.getElementById('first-name').value = firstName;
    document.getElementById('first-name').disabled = true;
    document.getElementById('last-name').value = lastName;
    document.getElementById('last-name').disabled = true;
    document.getElementById('email2').value = savedUserInformation.ReceiptEmail;
    document.getElementById('email2').disabled = true;
    document.getElementById('company-name').value = savedUserInformation.CompanyName;
    document.getElementById('company-name').disabled = true;
    document.getElementById('street-address').value = savedUserInformation.Address1;
    document.getElementById('street-address').disabled = true;
    document.getElementById('postal-code').value = savedUserInformation.ZipCode;
    document.getElementById('postal-code').disabled = true;
    document.getElementById('city').value = savedUserInformation.City;
    document.getElementById('city').disabled = true;
  } else {
    // Ej Inloggad
    console.log('Ej inloggad checkout');
    document.getElementById('swish-payment-wrap').classList.remove('hidden');
    document.getElementById('card-payment-wrap').classList.remove('hidden');
  }

  for (let i = 0; i < removeItemCartButtons.length; i++) {
    removeItemCartButtons[i].addEventListener('click', function(event) {
      const itemID = event.target.closest('tr').querySelector('.cart-item-id').textContent;

      event.target.closest('tr').remove();
      checkoutCartRemoveItem(itemID);
    });
  }
}

function decrement(e) {
  const btn = e.target.closest('td').querySelector(
    'button[data-action="decrement"]'
  );

  const target = btn.closest('td').querySelector(
    'input'
  );

  let value = Number(target.value);

  if (value > 1) {
    value--;
    target.value = value;
  }

  if (target.closest('tr').querySelector('.cart-item-id')) {
    const itemId = target.closest('tr').querySelector('.cart-item-id').textContent;
    if (itemId) {
      checkoutCartUpdateQty(itemId, value);
    }
  }
}

function increment(e) {
  const btn = e.target.closest('td').querySelector(
    'button[data-action="decrement"]'
  );

  const target = btn.closest('td').querySelector(
    'input'
  );

  let value = Number(target.value);
  value++;
  target.value = value;

  if (target.closest('tr').querySelector('.cart-item-id')) {
    const itemId = target.closest('tr').querySelector('.cart-item-id').textContent;
    if (itemId) {
      checkoutCartUpdateQty(itemId, value);
    }
  }
}

function clearInputs() {
  clearCart();
  const checkoutForm = document.getElementById('checkout-form');
  checkoutForm.reset();
}

export function sendCardPayment() {
  if (!localStorage.getItem('cart')) {
    manageErrorBox('Något gick fel', 'Varukorg saknas.');
    return;
  }
  const cart = JSON.parse(localStorage.getItem('cart'));
  let urlString = '';
  if (cart.length) {
    for (let i = 0; i < cart.length; i++) {
      urlString += `${cart[i].item}|${cart[i].qty}||`;
    }
  }

  const emptyCartIframe = '<iframe hidden src="https://www.honsboa.se/Checkout#empty" id="custom-empty-cart-iframe"></iframe>';
  const testIframe = document.getElementById('custom-empty-cart-iframe');
  if (testIframe) {
    testIframe.parentElement.removeChild(testIframe);
  }
  const body = document.getElementsByTagName('body');
  body[0].insertAdjacentHTML('beforeend', emptyCartIframe);

  setTimeout(function() {
    const htmlIframe = `
      <iframe hidden src="https://www.honsboa.se/Meny/Snabborder/#${urlString}" id="custom-order-iframe"></iframe>
    `;
    const iframe = document.getElementById('custom-order-iframe');
    if (iframe) {
      iframe.parentElement.removeChild(iframe);
    }
    body[0].insertAdjacentHTML('beforeend', htmlIframe);
    const customLoader = document.createElement('div');
    customLoader.innerHTML = `<div id="custom-loader" style="position: fixed;" class="inset-0 flex justify-center top-28" role="status">
        <svg aria-hidden="true" class="w-24 h-24 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
        </svg>
      </div>`;
    const checkElement = document.getElementById('custom-loader');
    if (typeof (checkElement) == 'undefined' || checkElement == null) {
      document.body.appendChild(customLoader);
    }
    setTimeout(function() {
      window.location.href = 'https://www.honsboa.se/Checkout';
    }, 5000);
  }, 1000);
}

export function sendBasketForPayment(typeOfPayment) {
  if (typeOfPayment != 'S' && typeOfPayment != 'I') {
    manageErrorBox('Något gick fel', 'Betalinformation saknas.');
    return;
  }

  let customerCode = '';
  let contactNo = '';
  let companyName = '';
  let customerName = '';
  let email = '';
  let streetAddress = '';
  let postalCode = '';
  let city = '';

  if (localStorage.getItem('wlUserInformation')) {
    const savedUserInformation = JSON.parse(localStorage.getItem('wlUserInformation'));
    customerCode = savedUserInformation.CustomerCode;
    contactNo = savedUserInformation.ContactNo;
    companyName = savedUserInformation.CompanyName;
    customerName = savedUserInformation.CustomerName;
    email = savedUserInformation.ReceiptEmail;
    streetAddress = savedUserInformation.Address1;
    postalCode = savedUserInformation.ZipCode;
    city = savedUserInformation.City;
  } else {
    if (typeOfPayment == 'I') {
      manageErrorBox('Något gick fel', 'Betalinformation saknas.');
      return;
    }

    customerCode = '';
    contactNo = '';
    companyName = document.getElementById('company-name').value;
    customerName = document.getElementById('first-name').value + ' ' + document.getElementById('last-name').value;
    email = document.getElementById('email2').value;
    streetAddress = document.getElementById('street-address').value;
    postalCode = document.getElementById('postal-code').value;
    city = document.getElementById('city').value;
  }
  if (!localStorage.getItem('cart')) {
    manageErrorBox('Något gick fel', 'Varukorg saknas.');
    return;
  }

  const cart = JSON.parse(localStorage.getItem('cart'));
  const mobile = document.getElementById('mobile').value;
  let total = 0;
  let rows = '';
  for (let i = 0; i < cart.length; i++) {
    const rowTotal = cart[i].price * cart[i].qty;
    rows += `<Row>
      <Item>${cart[i].item}</Item>
      <Qty>${cart[i].qty}</Qty>
      <Price>${cart[i].price}</Price>
      <Amount>${rowTotal}</Amount>
      </Row>`;
    total += rowTotal;
  }
  total = Math.round(total);
  if (isNaN(total) || total <= 0) {
    manageErrorBox('Något gick fel', 'Summan är inte korrekt.');
    return;
  }
  if (rows.length <= 0) {
    manageErrorBox('Något gick fel', 'Order saknar rader.');
    return;
  }

  let bodyXML = '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">';
  bodyXML += '<soap:Body>';
  bodyXML += '<SendBasketForPayment>';
  bodyXML += '<SecretKey>MG65Y0XPmQqNWrLeTCp2Rm11obRDDL7Y</SecretKey>';
  bodyXML += '<Customer>';
  bodyXML += '<CustomerCode>' + customerCode + '</CustomerCode>';
  bodyXML += '<ContactNo>' + contactNo + '</ContactNo>';
  bodyXML += '<CompanyName>' + companyName + '</CompanyName>';
  bodyXML += '<CustomerName>' + customerName + '</CustomerName>';
  bodyXML += '<Address1>' + streetAddress + '</Address1>';
  bodyXML += '<ZipCode>' + postalCode + '</ZipCode>';
  bodyXML += '<City>' + city + '</City>';
  bodyXML += '<ReceiptEmail>' + email + '</ReceiptEmail>';
  bodyXML += '</Customer>';
  bodyXML += '<Rows>';
  bodyXML += rows;
  bodyXML += '</Rows>';
  bodyXML += '<Total>' + total + '</Total>';
  bodyXML += '<PaymentMethod>' + typeOfPayment + '</PaymentMethod>';
  bodyXML += '<Mobileno>' + mobile + '</Mobileno>';
  bodyXML += '</SendBasketForPayment>';
  bodyXML += '</soap:Body>';
  bodyXML += '</soap:Envelope>';

  const headers = new Headers();
  headers.append('Content-Type', 'application/xml');
  const xhr = new XMLHttpRequest();
  xhr.addEventListener('load', function() {
    if (this.readyState === 4) {
      const parser = new xml2js.Parser({ explicitArray: false });
      parser.parseString(this.responseText, function(err, result) {
        console.log(err);
        if (result['soap:Envelope']['soap:Body'].SendBasketForPayment && result['soap:Envelope']['soap:Body'].SendBasketForPayment.Status && result['soap:Envelope']['soap:Body'].SendBasketForPayment.Status == 'Success') {
          if (typeOfPayment == 'I') {
            const PaymentRequestId = result['soap:Envelope']['soap:Body'].SendBasketForPayment.SwishRequestId;
            setBasketStatus(PaymentRequestId, 'Done', '', false);
          } else {
            const PaymentRequestId = result['soap:Envelope']['soap:Body'].SendBasketForPayment.SwishRequestId;

            $.post('https://pyramidplus.webblandskapet.se/debug/index.php', { company: 'honsboa', data: PaymentRequestId, action: 'createSwishPayment' });

            createSwishPayment(total, 'Order ref ' + PaymentRequestId, PaymentRequestId);
          }
        } else if (result['soap:Envelope']['soap:Body']['soap:Fault']) {
          const error = result['soap:Envelope']['soap:Body']['soap:Fault'];
          manageErrorBox('Något gick fel', error.faultstring);
        } else {
          manageErrorBox('Något gick fel', 'Något gick fel vid betalningen.');
        }
      });
    } else {
      manageErrorBox('Något gick fel', 'Något gick fel vid fakturabetalning.');
    }
  });

  xhr.open('POST', 'https://butik.honsboa.se/cors.php');
  xhr.setRequestHeader('Content-Type', 'application/xml');
  xhr.send(bodyXML);
}

function createSwishPayment(amount, message, PaymentRequestId) {
  const payload = {};
  payload.version = 1;
  payload.payee = {};
  payload.payee.value = '1231139849';
  payload.payee.editable = false;
  payload.amount = {};
  payload.amount.value = amount;
  payload.amount.editable = false;
  payload.message = {};
  payload.message.value = message;
  payload.amount.editable = false;

  const encodedPayload = encodeURIComponent(JSON.stringify(payload));
  const encodedCallbackURL = encodeURIComponent(window.location.origin + window.location.pathname + '?swish=done&requestid=' + PaymentRequestId);
  window.location.href = 'swish://payment?data=' + encodedPayload + '&callbackurl=' + encodedCallbackURL + '&callbackresultparameter=status';
}

export function setBasketStatus(PaymentRequestId, status, text, swish) {
  if (status == 'Done') {
    clearInputs();
    if (swish) {
      manageSuccessBox('Tack för din betalning, vi registrerar nu ditt köp', text, true);
    }
  }
  let bodyXML = '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">';
  bodyXML += '<soap:Body>';
  bodyXML += '<SetBasketAsFinished>';
  bodyXML += '<SecretKey>MG65Y0XPmQqNWrLeTCp2Rm11obRDDL7Y</SecretKey>';
  bodyXML += '<PaymentRequestId>' + PaymentRequestId + '</PaymentRequestId>';
  bodyXML += '<Status>' + status + '</Status>';
  bodyXML += '</SetBasketAsFinished>';
  bodyXML += '</soap:Body>';
  bodyXML += '</soap:Envelope>';

  const headers = new Headers();
  headers.append('Content-Type', 'application/xml');
  const xhr = new XMLHttpRequest();
  xhr.addEventListener('load', function() {
    const purchaseButton = document.getElementById('purchase-button');
    purchaseButton.disabled = false;
    purchaseButton.textContent = 'Slutför';

    if (this.readyState === 4) {
      const parser = new xml2js.Parser({ explicitArray: false });
      parser.parseString(this.responseText, function(err, result) {
        const error = result['soap:Envelope']['soap:Body']['soap:Fault'];
        if (err || result == null || error) {
          manageErrorBox('Något gick fel', 'Något gick fel vid fakturabetalning.');
        } else {
          // TODO om status success visa kvittonummer
          if (status == 'Done') {
            if (swish) {
              stopSpinnerSucessBox('Tack för din betalning, ditt köp är registrerat', text);
            } else {
              manageSuccessBox('Tack för din beställning', text);
            }
          } else {
            manageErrorBox('Något gick fel', text);
          }
        }
      });
    } else {
      manageErrorBox('Något gick fel', 'Något gick fel vid fakturabetalning.');
    }
  });
  xhr.open('POST', 'https://butik.honsboa.se/cors.php');
  xhr.setRequestHeader('Content-Type', 'application/xml');
  xhr.send(bodyXML);
}

function validateDecimal(e) {
  let newValue = e.target.value;
  let noDecimals = 0;
  const itemId = e.target.closest('tr').querySelector('.cart-item-id').textContent;
  if (e.target.getAttribute('data-decimals')) {
    noDecimals = e.target.getAttribute('data-decimals');
  }
  if (noDecimals == 0) {
    newValue = newValue.replace('.', '');
    newValue = newValue.replace(',', '');
    if (isNaN(newValue)) {
      newValue = 1;
    }
    e.target.value = newValue;
    if (itemId) {
      checkoutCartUpdateQty(itemId, newValue);
    }
  } else {
    if (countDecimals(newValue) > noDecimals) {
      newValue = parseFloat(newValue);
      e.target.value = newValue.toFixed(noDecimals);
      checkoutCartUpdateQty(itemId, newValue.toFixed(noDecimals));
    } else {
      checkoutCartUpdateQty(itemId, newValue);
    }
  }
}

function countDecimals(value) {
  if ((value % 1) != 0)
    return value.toString().split('.')[1].length;
  return 0;
}
